(function ($) {
    $(document).ready(function () {
        console.log("test1");
        $('.image-columns-block .card-title').each(function(){
            console.log($(this).outerHeight);
        })
    });
})(jQuery);
